<div #pixiOnboardingExperience></div>

@if (showMockBadge()) {
  <div class="mock-badge" id="mock-badge">
    <img src="assets/images/onboarding-experience/badge.svg" alt="Badging Info Mock User" />
  </div>
}

@if (showBadge()) {
  <app-badging-info
    id="badging-info"
    [userInput]="user()"
    [isOnboardingExperience]="true"
    [isPreviewCard]="true"
    [customStyle]="true"
    [previewBadgeInfo]="{
      userName: formatUserName(userInfo()?.firstName, userInfo()?.lastName),
      companyName: userInfo()?.companyName,
      userTitle: userInfo()?.title,
      aboutMe: userInfo()?.aboutMe,
    }"
  ></app-badging-info>
}

<div class="zoom-controls" [ngClass]="{ 'hide-component': hideZoom() }">
  <button
    title="Zoom In"
    class="zoom-button"
    [disabled]="inDisabled()"
    (mousedown)="startZoom(true)"
    (mouseup)="stopZoom()"
    (mouseleave)="stopZoom()"
    [disabled]="inDisabled()"
    [ngClass]="{ active: zoomDirection.value === 'in', disabled: inDisabled() }"
    data-test-id="zoom-in-button"
    type="button"
  >
    <mat-icon svgIcon="PLUS"></mat-icon>
  </button>
  @if (!autoZoomFlag) {
    <div class="controls-divider m-t-10 m-b-6"></div>
  }
  @if (autoZoomFlag) {
    <button
      type="button"
      [disabled]="inDisabled()"
      (click)="toggleAutoZoom()"
      [matTooltip]="autoZoomTooltip()"
      [matTooltipPosition]="'right'"
      class="auto-zoom-button p-2 enabled"
      [ngClass]="{ enabled: autoZoomEnabled, disabled: inDisabled() }"
      data-test-id="auto-zoom-button"
    >
      Auto
    </button>
  }
  <button
    title="Zoom Out"
    class="zoom-button"
    (mousedown)="startZoom(false)"
    (mouseup)="stopZoom()"
    (mouseleave)="stopZoom()"
    [disabled]="outDisabled()"
    [ngClass]="{ active: zoomDirection.value === 'out', disabled: outDisabled() }"
    data-test-id="zoom-out-button"
    type="button"
  >
    <mat-icon svgIcon="MINUS"></mat-icon>
  </button>
</div>
